
import { Component, Prop, Vue } from 'vue-property-decorator';

import { getSuburb } from '@/api';

import { ISelectSuburb } from '@/models/jbAdvanced';

@Component({})
export default class LookupSuburb extends Vue {
  @Prop({ type: Object, required: false }) public chosenSuburb: ISelectSuburb;
  @Prop({ type: String, required: false }) public name: string;
  @Prop({ type: Boolean, required: false }) public disabled: boolean;

  public loading = false;

  public inputValue = '';
  public selectItems: ISelectSuburb[] = [];

  public showOptions = false;
  public suburbChosen: ISelectSuburb = {
    name: '',
    id: -1,
    postcode: '',
    state: '',
  };
  public arrowIdx = -1;

  public async handleInput(evt: string): Promise<void> {
    if (evt || evt === '') {
      this.inputValue = evt;
    }
    if (this.inputValue.length >= 3) {
      this.loading = true;
      await getSuburb(this.inputValue)
        .then(data => {
          this.selectItems = data;
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = -1;
    }
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.selectItems.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      const item = this.selectItems[this.arrowIdx];
      this.suburbChosen = item;
      this.inputValue = `${item.name}`;
      this.showOptions = false;
      this.$emit('changed', item, this.name.slice(-1));
      this.arrowIdx = -1;
    }
  }

  // noinspection JSUnusedGlobalSymbols
  /**
   * Function that should be called from parent component where it's used to pass a reselected suburb
   * For example it is used when a suburb comes from the user's address book, and we don't have to make a real lookup
   * @param item
   * @private
   */
  private applyValueFromParent(item: ISelectSuburb): void {
    this.suburbChosen = item;
    this.inputValue = `${item.name}`;
    this.$forceUpdate();
  }

  private fixScrolling() {
    let scrollVal = 0;
    if (this.$refs.options) {
      const options = this.$refs.options as HTMLFormElement;
      // Find current option item
      options.map((option, idx) => {
        if (idx < this.arrowIdx) {
          scrollVal += option.clientHeight;
        }
      });
      // Scroll to top
      const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollVal;
      }
    }
  }

  public clearInput(): void {
    this.inputValue = '';
    this.showOptions = false;
    this.suburbChosen = {
      name: '',
      id: -1,
      postcode: '',
      state: '',
    };
    this.arrowIdx = -1;
    this.selectItems = [];
  }

  public inputFocused(): void {
    this.showOptions = true;
  }

  public inputBlured(): void {
    setTimeout(() => {
      this.showOptions = false;

      if (!this.suburbChosen) {
        this.inputValue = '';
      } else {
        if (typeof this.suburbChosen === 'object') {
          this.inputValue = `${this.suburbChosen.name}`;
        } else {
          this.inputValue = this.suburbChosen;
        }
      }
    }, 200);
  }

  public handleItemClick(item: ISelectSuburb): void {
    this.suburbChosen = item;
    this.showOptions = false;
    this.inputValue = `${item.name}`;
    this.$emit('changed', item, this.name.slice(-1));
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }
}
// };
